let managersData = [];
let sipAccountsData = [];
let selectedManagerId = null;

// Helper function to show notifications
function showNotification(message, isError = false) {
    const notification = document.createElement('div');
    notification.className = `fixed bottom-4 right-4 p-4 rounded-lg shadow-lg ${isError ? 'bg-red-600' : 'bg-green-600'} text-white z-50 flex items-center`;
    
    // Add icon based on type
    const iconSvg = document.createElement('div');
    iconSvg.className = 'mr-3';
    if (isError) {
        iconSvg.innerHTML = `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>`;
    } else {
        iconSvg.innerHTML = `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>`;
    }
    
    notification.appendChild(iconSvg);
    
    const messageSpan = document.createElement('span');
    messageSpan.textContent = message;
    notification.appendChild(messageSpan);
    
    document.body.appendChild(notification);
    
    // Fade out and remove
    setTimeout(() => {
        notification.style.opacity = '0';
        notification.style.transition = 'opacity 0.5s';
        setTimeout(() => {
            notification.remove();
        }, 500);
    }, 3000);
}

// Fetch managers data
function fetchManagers() {
    document.getElementById('managers-loading').style.display = 'flex';
    document.getElementById('managers-list').innerHTML = '';
    
    fetch('/api/managers/')
        .then(response => {
            if (!response.ok) {
                throw new Error('Не удалось загрузить данные менеджеров');
            }
            return response.json();
        })
        .then(data => {
            managersData = data.managers || [];
            renderManagersTable();
            document.getElementById('managers-loading').style.display = 'none';
        })
        .catch(error => {
            document.getElementById('managers-loading').style.display = 'none';
            document.getElementById('managers-list').innerHTML = `
                <div class="p-4 flex items-center text-red-600">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Ошибка: ${error.message}
                </div>`;
        });
}

// Fetch SIP accounts data
function fetchSipAccounts() {
    document.getElementById('sip-loading').style.display = 'flex';
    document.getElementById('free-sip-accounts').innerHTML = '';
    
    fetch('/api/sip_accounts/')
        .then(response => {
            if (!response.ok) {
                throw new Error('Не удалось загрузить данные SIP аккаунтов');
            }
            return response.json();
        })
        .then(data => {
            sipAccountsData = data.sip_accounts || [];
            renderSipAccountsTable();
            document.getElementById('sip-loading').style.display = 'none';
        })
        .catch(error => {
            document.getElementById('sip-loading').style.display = 'none';
            document.getElementById('free-sip-accounts').innerHTML = `
                <div class="p-4 flex items-center text-red-600">
                    <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Ошибка: ${error.message}
                </div>`;
        });
}

// Render managers table
function renderManagersTable() {
    if (managersData.length === 0) {
        document.getElementById('managers-list').innerHTML = '<div class="p-4 text-gray-600">Нет данных о менеджерах</div>';
        return;
    }

    let html = `
        <table class="min-w-full divide-y divide-gray-200 border-collapse">
            <thead class="bg-gray-100">
                <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">ID</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Имя</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Email</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Телефон</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">SIP аккаунт</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Действия</th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
    `;

    managersData.forEach(manager => {
        html += `
            <tr class="hover:bg-gray-50 transition-colors duration-150">
                <td class="px-6 py-4 whitespace-nowrap">
                    <div class="font-medium text-gray-900">${manager.id}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                    <div class="font-medium text-gray-900">${manager.name || '-'}</div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-gray-500">${manager.email || '-'}</td>
                <td class="px-6 py-4 whitespace-nowrap text-gray-500">${manager.phone || '-'}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                    ${manager.sip ? 
                        `<div class="flex items-center">
                            <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${manager.sip.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}">
                                ${manager.sip.status}
                            </span>
                            <span class="ml-2 text-gray-500">${manager.sip.username}</span>
                        </div>` : 
                        '<span class="text-gray-400">Не назначен</span>'}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                    ${manager.sip ? 
                        `<button data-manager-id="${manager.id}" class="unlink-sip text-sm text-red-600 hover:text-red-900 hover:underline flex items-center">
                            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 7l-5 5-5-5M17 17l-5-5-5 5"></path>
                            </svg>
                            Отвязать
                        </button>` : 
                        `<button data-manager-id="${manager.id}" data-manager-name="${manager.name}" class="link-sip text-sm text-primary-600 hover:text-primary-900 hover:underline flex items-center">
                            <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
                            </svg>
                            Связать
                        </button>`
                    }
                </td>
            </tr>
        `;
    });

    html += `
            </tbody>
        </table>
    `;

    document.getElementById('managers-list').innerHTML = html;
    
    // Add event listeners for link/unlink buttons
    document.querySelectorAll('.link-sip').forEach(button => {
        button.addEventListener('click', function() {
            selectedManagerId = this.dataset.managerId;
            const managerName = this.dataset.managerName;
            document.getElementById('selected-manager-name').textContent = managerName;
            populateSipSelectOptions();
            document.getElementById('link-modal').classList.remove('hidden');
        });
    });
    
    document.querySelectorAll('.unlink-sip').forEach(button => {
        button.addEventListener('click', function() {
            const managerId = this.dataset.managerId;
            unlinkManagerFromSip(managerId);
        });
    });
}

// Render SIP accounts table
function renderSipAccountsTable() {
    // Filter out SIP accounts that are already linked to managers
    const freeSipAccounts = sipAccountsData.filter(sip => !sip.is_linked);
    
    if (freeSipAccounts.length === 0) {
        document.getElementById('free-sip-accounts').innerHTML = '<div class="p-4 text-gray-600">Нет свободных SIP аккаунтов</div>';
        return;
    }

    let html = `
        <table class="min-w-full divide-y divide-gray-200 border-collapse">
            <thead class="bg-gray-100">
                <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">ID</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Имя пользователя</th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border-b-2 border-gray-200">Статус</th>
                </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
    `;

    freeSipAccounts.forEach(sip => {
        html += `
            <tr class="hover:bg-gray-50 transition-colors duration-150">
                <td class="px-6 py-4 whitespace-nowrap font-medium text-gray-900">${sip.sip_id}</td>
                <td class="px-6 py-4 whitespace-nowrap text-gray-500">${sip.username}</td>
                <td class="px-6 py-4 whitespace-nowrap">
                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${sip.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}">
                        ${sip.status}
                    </span>
                </td>
            </tr>
        `;
    });

    html += `
            </tbody>
        </table>
    `;

    document.getElementById('free-sip-accounts').innerHTML = html;
}

// Populate SIP select options in the modal
function populateSipSelectOptions() {
    const select = document.getElementById('sip-select');
    select.innerHTML = '';
    
    // Filter out SIP accounts that are already linked to managers
    const freeSipAccounts = sipAccountsData.filter(sip => !sip.is_linked);
    
    if (freeSipAccounts.length === 0) {
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'Нет доступных SIP аккаунтов';
        option.disabled = true;
        select.appendChild(option);
        document.getElementById('confirm-link').disabled = true;
        return;
    }
    
    document.getElementById('confirm-link').disabled = false;
    
    // Add default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Выберите SIP аккаунт';
    defaultOption.selected = true;
    defaultOption.disabled = true;
    select.appendChild(defaultOption);
    
    // Add SIP account options
    freeSipAccounts.forEach(sip => {
        const option = document.createElement('option');
        option.value = sip.id;
        option.textContent = `${sip.sip_id} - ${sip.username} (${sip.status})`;
        select.appendChild(option);
    });
}

// Link manager to SIP account
function linkManagerToSip() {
    const sipId = document.getElementById('sip-select').value;
    
    if (!sipId) {
        showNotification('Выберите SIP аккаунт', true);
        return;
    }
    
    // Get CSRF token from the page
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    
    fetch('/api/link_manager_to_sip/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        body: JSON.stringify({
            manager_id: selectedManagerId,
            sip_id: sipId
        })
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => {
                throw new Error(data.error || 'Ошибка при связывании менеджера с SIP аккаунтом');
            });
        }
        return response.json();
    })
    .then(data => {
        document.getElementById('link-modal').classList.add('hidden');
        showNotification('Менеджер успешно связан с SIP аккаунтом');
        
        // Refresh data
        fetchManagers();
        fetchSipAccounts();
    })
    .catch(error => {
        showNotification(error.message, true);
    });
}

// Unlink manager from SIP account
function unlinkManagerFromSip(managerId) {
    // Get CSRF token from the page
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    
    fetch('/api/unlink_manager_from_sip/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        body: JSON.stringify({
            manager_id: managerId
        })
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => {
                throw new Error(data.error || 'Ошибка при отвязывании SIP аккаунта от менеджера');
            });
        }
        return response.json();
    })
    .then(data => {
        showNotification('SIP аккаунт успешно отвязан от менеджера');
        // Refresh data
        fetchManagers();
        fetchSipAccounts();
    })
    .catch(error => {
        showNotification(error.message, true);
    });
}

// Set up event listeners
function setupEventListeners() {
    // Get CSRF token from the page
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    
    document.getElementById('refresh-managers').addEventListener('click', function() {
        fetch('/api/refresh_managers/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrfToken
            }
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.error || 'Ошибка при обновлении менеджеров');
                });
            }
            return response.json();
        })
        .then(data => {
            showNotification(`Список менеджеров обновлен. Добавлено: ${data.created}, обновлено: ${data.updated}`);
            fetchManagers();
        })
        .catch(error => {
            showNotification(error.message, true);
        });
    });

    document.getElementById('refresh-sip').addEventListener('click', function() {
        fetch('/api/refresh_sip_accounts/', {
            method: 'POST',
            headers: {
                'X-CSRFToken': csrfToken
            }
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.error || 'Ошибка при обновлении SIP аккаунтов');
                });
            }
            return response.json();
        })
        .then(data => {
            showNotification(`Список SIP аккаунтов обновлен. Добавлено: ${data.created}, обновлено: ${data.updated}`);
            fetchSipAccounts();
        })
        .catch(error => {
            showNotification(error.message, true);
        });
    });

    // Close modal listeners
    document.getElementById('cancel-link').addEventListener('click', function() {
        document.getElementById('link-modal').classList.add('hidden');
    });

    document.getElementById('close-modal').addEventListener('click', function() {
        document.getElementById('link-modal').classList.add('hidden');
    });

    document.getElementById('confirm-link').addEventListener('click', linkManagerToSip);
    
    // Add manager modal listeners
    document.getElementById('add-manager').addEventListener('click', function() {
        document.getElementById('add-manager-modal').classList.remove('hidden');
        document.getElementById('add-manager-form').reset();
    });
    
    document.getElementById('cancel-add-manager').addEventListener('click', function() {
        document.getElementById('add-manager-modal').classList.add('hidden');
    });
    
    document.getElementById('close-add-manager-modal').addEventListener('click', function() {
        document.getElementById('add-manager-modal').classList.add('hidden');
    });
    
    document.getElementById('confirm-add-manager').addEventListener('click', addManager);
}

// Add new manager
function addManager() {
    const form = document.getElementById('add-manager-form');
    const formData = new FormData(form);
    
    // Validate required fields
    const name = formData.get('name');
    const email = formData.get('email');
    
    if (!name || !email) {
        showNotification('Заполните обязательные поля (Имя и Email)', true);
        return;
    }
    
    // Get CSRF token from the page
    const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;
    
    const managerData = {
        name: name,
        email: email,
        phone: formData.get('phone') || '',
        position: formData.get('position') || '',
        bitrix_id: formData.get('bitrix_id') || null
    };
    
    fetch('/api/add_manager/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        body: JSON.stringify(managerData)
    })
    .then(response => {
        if (!response.ok) {
            return response.json().then(data => {
                throw new Error(data.error || 'Ошибка при добавлении менеджера');
            });
        }
        return response.json();
    })
    .then(data => {
        document.getElementById('add-manager-modal').classList.add('hidden');
        showNotification('Менеджер успешно добавлен');
        
        // Refresh managers list
        fetchManagers();
    })
    .catch(error => {
        showNotification(error.message, true);
    });
}

// Initialize managers page
document.addEventListener('DOMContentLoaded', function() {
    setupEventListeners();
    fetchManagers();
    fetchSipAccounts();
});

export { fetchManagers, fetchSipAccounts };
